module.exports = __webpack_public_path__ + "img/car.8a811c4d.png";